import { __ } from '@wordpress/i18n';
import { InnerBlocks } from '@wordpress/block-editor';


export default function save(props){

    const { attributes} = props;
    const { blockId, pageLoad, timeToLoad, classRelated } = attributes;

    return(
        <div className={`modal-contents`} data-set={classRelated} data-auto={timeToLoad}>
            <div className='modal-contents__positions'>
                <span class="dashicons dashicons-no-alt js-close-moddal"></span>
                <InnerBlocks.Content />
            </div>
        </div>

    );

    
}

